import type { ReactNode } from 'react';
import styles from './states.module.css';

export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className={styles.center}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <h2 className={styles.title}>{title}</h2>
      {description && <p className={styles.muted}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
